<div class="sticky-top">
  <div
    class="d-flex align-items-center justify-content-between navbar-primary pl-md-3 pr-md-2"
  >
    <div>
      <a routerLink="dashboard" aria-label="Dashboard">
        <img src="assets/logo/ingo-logo.svg" alt="" width="48" height="48" />
      </a>
    </div>
    <div class="d-md-none font-weight-bold">
      <ng-container *ngIf="currentRoute[0] === 'dashboard'"
        >{{ "navbar.links.dashboard" | translate }}
      </ng-container>
      <ng-container *ngIf="currentRoute[0] === 'transactions'"
        >{{ "navbar.links.transactions" | translate }}
      </ng-container>
      <ng-container *ngIf="currentRoute[0] === 'invoices'"
        >{{ "navbar.links.invoices" | translate }}
      </ng-container>
      <ng-container *ngIf="currentRoute[0] === 'free-liters'"
        >{{ "navbar.links.freeLiters" | translate }}
      </ng-container>
      <ng-container *ngIf="currentRoute[0] === 'cards'"
        >{{ "navbar.links.cards" | translate }}
      </ng-container>
      <ng-container *ngIf="currentRoute[0] === 'user-profile'"
        >{{ "navbar.links.profile" | translate }}
      </ng-container>
    </div>
    <div>
      <button
        class="btn btn-link btn-nav d-md-none btn-mobile-nav-toggle"
        type="button"
        (click)="toggleMobileNav()"
      >
        <fa-icon
          [icon]="faBars"
          [fixedWidth]="true"
          *ngIf="mobileNavState === 'closed'"
        ></fa-icon>
        <fa-icon
          [icon]="faTimes"
          [fixedWidth]="true"
          *ngIf="mobileNavState === 'open'"
        ></fa-icon>
      </button>

      <span class="d-none d-md-inline-block">
        <button type="button" class="btn btn-link btn-nav" (click)="goToFaq()">
          <fa-icon [icon]="faQuestionCircle"></fa-icon>
          {{ "navbar.links.faq" | translate }}
        </button>

        <span class="px-2" ngbDropdown placement="bottom-right">
          <button type="button" class="btn btn-link btn-nav" ngbDropdownToggle>
            <fa-icon [icon]="faLanguage" size="lg"></fa-icon>
            {{ currentLanguage.name }}
          </button>
          <div ngbDropdownMenu>
            <button
              class="dropdown-item"
              (click)="selectLanguage(languages.SWEDISH)"
            >
              {{ languages.SWEDISH.name }}
            </button>
            <button
              class="dropdown-item"
              (click)="selectLanguage(languages.DANISH)"
            >
              {{ languages.DANISH.name }}
            </button>
            <button
              class="dropdown-item"
              (click)="selectLanguage(languages.ENGLISH)"
            >
              {{ languages.ENGLISH.name }}
            </button>
          </div>
        </span>

        <span ngbDropdown placement="bottom-right">
          <button
            type="button"
            class="btn btn-link text-size-base btn-nav"
            ngbDropdownToggle
          >
            {{ user.firstName }} {{ user.lastName }}
            <ingo-initials-avatar
              class="initials-avatar"
              [firstName]="user.firstName"
              [lastName]="user.lastName"
            ></ingo-initials-avatar>
          </button>
          <div ngbDropdownMenu>
            <button
              class="dropdown-item"
              routerLink="/user-profile"
              *ngIf="!accessBlocked"
            >
              <img alt="" src="/assets/icons/user.svg" class="user-icon mr-1" />
              {{ "navbar.links.profile" | translate }}
            </button>
            <button class="dropdown-item" (click)="logOut()">
              <img
                alt=""
                src="/assets/icons/log-out.svg"
                class="logout-icon mr-1"
              />
              {{ "navbar.logOut" | translate }}
            </button>
          </div>
        </span>
      </span>
    </div>
  </div>

  <div
    class="d-none d-md-block text-center bg-white navbar-secondary p-3"
    *ngIf="!accessBlocked"
  >
    <ul class="nav justify-content-center">
      <li class="nav-item px-3">
        <a
          aria-label="Dashboard"
          class="nav-link px-0"
          routerLink="dashboard"
          routerLinkActive="active"
        >
          {{ "navbar.links.dashboard" | translate }}
        </a>
      </li>
      <li class="nav-item px-3">
        <a
          aria-label="Transactions"
          class="nav-link px-0"
          routerLink="transactions"
          routerLinkActive="active"
        >
          {{ "navbar.links.transactions" | translate }}
        </a>
      </li>
      <li class="nav-item px-3" *ngIf="invoicesVisible()">
        <a
          aria-label="Invoices"
          class="nav-link px-0"
          routerLink="invoices"
          routerLinkActive="active"
        >
          {{ "navbar.links.invoices" | translate }}
        </a>
      </li>
      <li class="nav-item px-3">
        <a
          aria-label="Free Liters"
          class="nav-link px-0"
          routerLink="free-liters"
          routerLinkActive="active"
        >
          {{ "navbar.links.freeLiters" | translate }}
        </a>
      </li>
      <li class="nav-item px-3">
        <a
          aria-label="Cards"
          class="nav-link px-0"
          routerLink="cards"
          routerLinkActive="active"
        >
          {{ "navbar.links.cards" | translate }}
        </a>
      </li>
    </ul>
  </div>

  <div
    class="d-md-none bg-white border-bottom mobile-nav"
    [@mobileNavState]="mobileNavState"
  >
    <ul class="nav flex-column border-bottom px-3 py-2" *ngIf="!accessBlocked">
      <li class="nav-item">
        <a
          aria-label="Dashboard"
          class="nav-link font-weight-bold p-1"
          routerLink="dashboard"
          (click)="closeMobileNav()"
        >
          {{ "navbar.links.dashboard" | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          aria-label="Transactions"
          class="nav-link font-weight-bold p-1"
          routerLink="transactions"
          (click)="closeMobileNav()"
        >
          {{ "navbar.links.transactions" | translate }}
        </a>
      </li>
      <li class="nav-item" *ngIf="invoicesVisible()">
        <a
          aria-label="Invoices"
          class="nav-link font-weight-bold p-1"
          routerLink="invoices"
          (click)="closeMobileNav()"
        >
          {{ "navbar.links.invoices" | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          aria-label="Free Liters"
          class="nav-link font-weight-bold p-1"
          routerLink="free-liters"
          (click)="closeMobileNav()"
        >
          {{ "navbar.links.freeLiters" | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          aria-label="Cards"
          class="nav-link font-weight-bold p-1"
          routerLink="cards"
          (click)="closeMobileNav()"
        >
          {{ "navbar.links.cards" | translate }}
        </a>
      </li>
    </ul>
    <ul class="nav flex-column border-bottom px-3 py-2">
      <li class="nav-item">
        <a
          aria-label="FAQ"
          class="nav-link font-weight-bold p-1"
          href="{{ faqUrl }}"
          target="_blank"
          (click)="closeMobileNav()"
        >
          {{ "navbar.links.faq" | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          aria-label="Language"
          class="nav-link font-weight-bold p-1"
          (click)="toggleMobileLangSelect()"
        >
          <fa-icon [icon]="faLanguage" size="lg" class="mr-1"></fa-icon>
          {{ currentLanguage.name }}
          <fa-icon
            [icon]="faCaretDown"
            class="ml-1"
            *ngIf="mobileLangSelectCollapsed"
          ></fa-icon>
          <fa-icon
            [icon]="faCaretUp"
            class="ml-1"
            *ngIf="!mobileLangSelectCollapsed"
          ></fa-icon>
        </a>
        <ul
          class="mobile-lang-select px-3 py-2"
          [ngbCollapse]="mobileLangSelectCollapsed"
        >
          <li class="nav-item">
            <a
              class="nav-link font-weight-bold p-1"
              (click)="selectLanguage(languages.SWEDISH)"
              >{{ languages.SWEDISH.name }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link font-weight-bold p-1"
              (click)="selectLanguage(languages.DANISH)"
              >{{ languages.DANISH.name }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link font-weight-bold p-1"
              (click)="selectLanguage(languages.ENGLISH)"
              >{{ languages.ENGLISH.name }}</a
            >
          </li>
        </ul>
      </li>
    </ul>
    <ul class="nav flex-column p-3">
      <li class="nav-item" *ngIf="!accessBlocked">
        <a
          aria-label="Profile"
          class="nav-link font-weight-bold p-1"
          routerLink="/user-profile"
          (click)="closeMobileNav()"
        >
          <img alt="" src="/assets/icons/user.svg" class="user-icon mr-1" />
          {{ "navbar.links.profile" | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          aria-label="Log Out"
          class="nav-link font-weight-bold p-1"
          (click)="logOut()"
          (click)="closeMobileNav()"
        >
          <img
            alt=""
            src="/assets/icons/log-out.svg"
            class="logout-icon mr-1"
          />
          {{ "navbar.logOut" | translate }}
        </a>
      </li>
    </ul>
  </div>

  <ingo-alerts-container></ingo-alerts-container>
</div>
